var _rect, _mask, _path, _rect2, _g, _tspan, _mask2, _path2, _rect3, _g2, _tspan2, _mask3, _path3, _rect4, _g3, _tspan3, _mask4, _path4, _rect5, _g4, _tspan4, _mask5, _path5, _rect6, _g5, _tspan5, _mask6, _path6, _rect7, _g6, _tspan6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottombar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 109,
    viewBox: "0 0 411 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45800)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 69,
    transform: "translate(20.5 35)",
    className: "id-main"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 35H82.8333V104H21.5V35Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 37H82.8333V33H21.5V37Z",
    className: "id-contrast",
    mask: "url(#path-1-inside-1_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 45,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1667,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 68V66H43.1667C43.7 66 44.2167 65.9167 44.7167 65.75C45.2167 65.5833 45.7 65.3333 46.1667 65C46.6333 65.3333 47.1167 65.5792 47.6167 65.7375C48.1167 65.8958 48.6333 65.975 49.1667 65.975C49.7 65.975 50.2208 65.8958 50.7292 65.7375C51.2375 65.5792 51.7167 65.3333 52.1667 65C52.6333 65.3333 53.1167 65.5792 53.6167 65.7375C54.1167 65.8958 54.6333 65.975 55.1667 65.975C55.7 65.975 56.2208 65.8958 56.7292 65.7375C57.2375 65.5792 57.7167 65.3333 58.1667 65C58.6167 65.3333 59.0958 65.5833 59.6042 65.75C60.1125 65.9167 60.6333 66 61.1667 66H62.1667V68H61.1667C60.65 68 60.1417 67.9375 59.6417 67.8125C59.1417 67.6875 58.65 67.5 58.1667 67.25C57.6833 67.5 57.1917 67.6875 56.6917 67.8125C56.1917 67.9375 55.6833 68 55.1667 68C54.65 68 54.1417 67.9375 53.6417 67.8125C53.1417 67.6875 52.65 67.5 52.1667 67.25C51.6833 67.5 51.1917 67.6875 50.6917 67.8125C50.1917 67.9375 49.6833 68 49.1667 68C48.65 68 48.1417 67.9375 47.6417 67.8125C47.1417 67.6875 46.65 67.5 46.1667 67.25C45.6833 67.5 45.1917 67.6875 44.6917 67.8125C44.1917 67.9375 43.6833 68 43.1667 68H42.1667ZM48.6667 49L54.2167 50.025C54.45 50.0583 54.675 50.15 54.8917 50.3C55.1083 50.45 55.2917 50.6583 55.4417 50.925L56.3167 52.475C56.75 53.225 57.35 53.8333 58.1167 54.3C58.8833 54.7667 59.7333 55 60.6667 55V57C59.3667 57 58.1833 56.675 57.1167 56.025C56.05 55.375 55.2083 54.525 54.5917 53.475C54.575 53.4917 54.4583 53.5708 54.2417 53.7125C54.025 53.8542 53.7875 54.0125 53.5292 54.1875C53.2708 54.3625 53.025 54.5292 52.7917 54.6875C52.5583 54.8458 52.4083 54.95 52.3417 55L53.0292 55.55C53.4042 55.85 53.8125 56.1708 54.2542 56.5125C54.6958 56.8542 55.1042 57.1708 55.4792 57.4625C55.8542 57.7542 56.0833 57.9333 56.1667 58V61.85C56.4333 62.0333 56.6917 62.225 56.9417 62.425C57.1917 62.625 57.4333 62.8167 57.6667 63C57.3167 63.3 56.9333 63.5417 56.5167 63.725C56.1 63.9083 55.65 64 55.1667 64C54.5667 64 54.0083 63.8583 53.4917 63.575C52.975 63.2917 52.5333 62.9333 52.1667 62.5C51.8 62.9333 51.3583 63.2917 50.8417 63.575C50.325 63.8583 49.7667 64 49.1667 64C49 64 48.8375 63.9875 48.6792 63.9625C48.5208 63.9375 48.3667 63.9 48.2167 63.85C46.7833 62.8667 45.5833 61.875 44.6167 60.875C43.65 59.875 43.1667 59.0083 43.1667 58.275C43.1667 57.7583 43.3667 57.4167 43.7667 57.25C44.1667 57.0833 44.5833 57 45.0167 57C45.5 57 46.0583 57.0708 46.6917 57.2125C47.325 57.3542 48 57.5583 48.7167 57.825L48.1917 54.725C48.125 54.3917 48.1625 54.0625 48.3042 53.7375C48.4458 53.4125 48.6667 53.15 48.9667 52.95L51.1167 51.5C51.0667 51.5 50.9458 51.4792 50.7542 51.4375C50.5625 51.3958 50.35 51.3542 50.1167 51.3125C49.8833 51.2708 49.6708 51.2292 49.4792 51.1875C49.2875 51.1458 49.1667 51.125 49.1167 51.125L46.2917 53.05L45.1667 51.4L48.6667 49ZM50.4667 56.1L50.9167 58.75C51.3667 58.9667 51.925 59.2542 52.5917 59.6125C53.2583 59.9708 53.7833 60.2667 54.1667 60.5V59C54.1167 58.9667 53.9083 58.8042 53.5417 58.5125C53.175 58.2208 52.775 57.9083 52.3417 57.575C51.9083 57.2417 51.5042 56.925 51.1292 56.625C50.7542 56.325 50.5333 56.15 50.4667 56.1ZM57.1667 50.5C56.6167 50.5 56.1458 50.3042 55.7542 49.9125C55.3625 49.5208 55.1667 49.05 55.1667 48.5C55.1667 47.95 55.3625 47.4792 55.7542 47.0875C56.1458 46.6958 56.6167 46.5 57.1667 46.5C57.7167 46.5 58.1875 46.6958 58.5792 47.0875C58.9708 47.4792 59.1667 47.95 59.1667 48.5C59.1667 49.05 58.9708 49.5208 58.5792 49.9125C58.1875 50.3042 57.7167 50.5 57.1667 50.5Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-contrast",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 37.6667,
    y: 90.598
  }, "SURF"))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8333 35H144.167V104H82.8333V35Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8333 37H144.167V33H82.8333V37Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-6-inside-2_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 45,
    width: 25,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.1 66.0001L114.75 59.6501L116.15 58.2501L122.5 64.6001L121.1 66.0001ZM107.45 65.3001C106.45 64.3001 105.708 63.1751 105.225 61.9251C104.742 60.6751 104.5 59.4001 104.5 58.1001C104.5 56.8001 104.742 55.5334 105.225 54.3001C105.708 53.0668 106.45 51.9501 107.45 50.9501C108.45 49.9501 109.571 49.2043 110.812 48.7126C112.054 48.2209 113.325 47.9751 114.625 47.9751C115.925 47.9751 117.196 48.2209 118.437 48.7126C119.679 49.2043 120.8 49.9501 121.8 50.9501L107.45 65.3001ZM107.65 62.2501L109 60.9001C108.733 60.5501 108.479 60.1918 108.237 59.8251C107.996 59.4584 107.775 59.0918 107.575 58.7251C107.375 58.3584 107.2 57.9918 107.05 57.6251C106.9 57.2584 106.767 56.9001 106.65 56.5501C106.467 57.5334 106.454 58.5168 106.612 59.5001C106.771 60.4834 107.117 61.4001 107.65 62.2501ZM110.45 59.5001L116 53.9001C115.283 53.3501 114.562 52.9043 113.837 52.5626C113.112 52.2209 112.433 51.9876 111.8 51.8626C111.167 51.7376 110.596 51.7168 110.087 51.8001C109.579 51.8834 109.183 52.0668 108.9 52.3501C108.617 52.6501 108.433 53.0543 108.35 53.5626C108.267 54.0709 108.287 54.6459 108.412 55.2876C108.537 55.9293 108.771 56.6084 109.112 57.3251C109.454 58.0418 109.9 58.7668 110.45 59.5001ZM117.4 52.5001L118.8 51.1501C117.917 50.6168 116.983 50.2668 116 50.1001C115.017 49.9334 114.033 49.9501 113.05 50.1501C113.417 50.2668 113.783 50.4001 114.15 50.5501C114.517 50.7001 114.883 50.8709 115.25 51.0626C115.617 51.2543 115.979 51.4709 116.337 51.7126C116.696 51.9543 117.05 52.2168 117.4 52.5001Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 95.5,
    y: 90.598
  }, "RELAX")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.167 35H205.5V104H144.167V35Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.167 37H205.5V33H144.167V37Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-11-inside-3_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 45,
    width: 25,
    height: 24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.833,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.833 66V64C165.467 64 165.942 63.8333 166.258 63.5C166.575 63.1667 167.2 63 168.133 63C169.067 63 169.708 63.1667 170.058 63.5C170.408 63.8333 170.883 64 171.483 64C172.083 64 172.558 63.8333 172.908 63.5C173.258 63.1667 173.9 63 174.833 63C175.767 63 176.408 63.1667 176.758 63.5C177.108 63.8333 177.583 64 178.183 64C178.783 64 179.258 63.8333 179.608 63.5C179.958 63.1667 180.6 63 181.533 63C182.467 63 183.092 63.1667 183.408 63.5C183.725 63.8333 184.2 64 184.833 64V66C183.85 66 183.204 65.8333 182.896 65.5C182.587 65.1667 182.133 65 181.533 65C180.933 65 180.458 65.1667 180.108 65.5C179.758 65.8333 179.117 66 178.183 66C177.25 66 176.608 65.8333 176.258 65.5C175.908 65.1667 175.433 65 174.833 65C174.233 65 173.758 65.1667 173.408 65.5C173.058 65.8333 172.417 66 171.483 66C170.55 66 169.908 65.8333 169.558 65.5C169.208 65.1667 168.733 65 168.133 65C167.533 65 167.079 65.1667 166.771 65.5C166.462 65.8333 165.817 66 164.833 66ZM164.833 61.5V59.5C165.467 59.5 165.942 59.3333 166.258 59C166.575 58.6667 167.2 58.5 168.133 58.5C169.067 58.5 169.712 58.6667 170.071 59C170.429 59.3333 170.9 59.5 171.483 59.5C172.083 59.5 172.558 59.3333 172.908 59C173.258 58.6667 173.9 58.5 174.833 58.5C175.767 58.5 176.408 58.6667 176.758 59C177.108 59.3333 177.583 59.5 178.183 59.5C178.783 59.5 179.258 59.3333 179.608 59C179.958 58.6667 180.6 58.5 181.533 58.5C182.467 58.5 183.092 58.6667 183.408 59C183.725 59.3333 184.2 59.5 184.833 59.5V61.5C183.85 61.5 183.204 61.3333 182.896 61C182.587 60.6667 182.133 60.5 181.533 60.5C180.933 60.5 180.471 60.6667 180.146 61C179.821 61.3333 179.167 61.5 178.183 61.5C177.233 61.5 176.587 61.3333 176.246 61C175.904 60.6667 175.433 60.5 174.833 60.5C174.2 60.5 173.729 60.6667 173.421 61C173.112 61.3333 172.467 61.5 171.483 61.5C170.5 61.5 169.846 61.3333 169.521 61C169.196 60.6667 168.733 60.5 168.133 60.5C167.533 60.5 167.079 60.6667 166.771 61C166.462 61.3333 165.817 61.5 164.833 61.5ZM169.733 56.4L173.058 53.075L172.058 52.075C171.508 51.525 170.925 51.125 170.308 50.875C169.692 50.625 168.933 50.5 168.033 50.5V48C169.283 48 170.317 48.1375 171.133 48.4125C171.95 48.6875 172.75 49.2167 173.533 50L179.933 56.4C179.65 56.5833 179.375 56.7292 179.108 56.8375C178.842 56.9458 178.533 57 178.183 57C177.583 57 177.108 56.8333 176.758 56.5C176.408 56.1667 175.767 56 174.833 56C173.9 56 173.258 56.1667 172.908 56.5C172.558 56.8333 172.083 57 171.483 57C171.133 57 170.825 56.9458 170.558 56.8375C170.292 56.7292 170.017 56.5833 169.733 56.4ZM179.533 48C180.233 48 180.825 48.2458 181.308 48.7375C181.792 49.2292 182.033 49.8167 182.033 50.5C182.033 51.2 181.792 51.7917 181.308 52.275C180.825 52.7583 180.233 53 179.533 53C178.833 53 178.242 52.7583 177.758 52.275C177.275 51.7917 177.033 51.2 177.033 50.5C177.033 49.8167 177.275 49.2292 177.758 48.7375C178.242 48.2458 178.833 48 179.533 48Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.833,
    y: 90.598
  }, "SWIM")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-4_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 35H266.833V104H205.5V35Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 37H266.833V33H205.5V37Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-16-inside-4_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 45,
    width: 25,
    height: 24
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.167,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.167 66V64H235.167V59L227.167 50V48H245.167V50L237.167 59V64H242.167V66H230.167ZM231.617 52H240.717L242.517 50H229.817L231.617 52ZM236.167 57.1L238.942 54H233.392L236.167 57.1Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 218.667,
    y: 90.598
  }, "DRIKN")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-5_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.833 35H328.167V104H266.833V35Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.833 37H328.167V33H266.833V37Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-21-inside-5_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 285,
    y: 45,
    width: 25,
    height: 24
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.5 64V49H288.5V59H296.5V51H304.5C305.6 51 306.542 51.3917 307.325 52.175C308.108 52.9583 308.5 53.9 308.5 55V64H306.5V61H288.5V64H286.5ZM292.5 58C291.667 58 290.958 57.7083 290.375 57.125C289.792 56.5417 289.5 55.8333 289.5 55C289.5 54.1667 289.792 53.4583 290.375 52.875C290.958 52.2917 291.667 52 292.5 52C293.333 52 294.042 52.2917 294.625 52.875C295.208 53.4583 295.5 54.1667 295.5 55C295.5 55.8333 295.208 56.5417 294.625 57.125C294.042 57.7083 293.333 58 292.5 58ZM298.5 59H306.5V55C306.5 54.45 306.304 53.9792 305.913 53.5875C305.521 53.1958 305.05 53 304.5 53H298.5V59ZM292.5 56C292.783 56 293.021 55.9042 293.213 55.7125C293.404 55.5208 293.5 55.2833 293.5 55C293.5 54.7167 293.404 54.4792 293.213 54.2875C293.021 54.0958 292.783 54 292.5 54C292.217 54 291.979 54.0958 291.787 54.2875C291.596 54.4792 291.5 54.7167 291.5 55C291.5 55.2833 291.596 55.5208 291.787 55.7125C291.979 55.9042 292.217 56 292.5 56Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 281,
    y: 90.598
  }, "SLEEP")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-6_1002_45800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.167 35H389.5V104H328.167V35Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.167 37H389.5V33H328.167V37Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-26-inside-6_1002_45800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1002_45800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 45,
    width: 25,
    height: 24
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 346.833,
    y: 45,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1002_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.167 63V61H360.167V63H358.167ZM358.167 58V56H360.167V58H358.167ZM358.167 53V51H360.167V53H358.167Z",
    className: "id-foreground"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "id-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 341.833,
    y: 90.598
  }, "MORE"))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45800",
    x: 0.5,
    y: 0,
    width: 410,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45800"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45800",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottombar);
export default __webpack_public_path__ + "static/media/bottombar.b6d116402d919fd3d9bff40a1066b4fa.svg";
export { ForwardRef as ReactComponent };